export { default } from './SpotChartsPageContainer';
